// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-wrapper[data-v-62ca54e4] {\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
